import * as React from 'react';
import { connect } from 'react-redux';
import { getOperationSafe, getOperation } from 'selectors';
import { IState } from 'services/root-reducer';
import {
    MapLinkOverlayOperation,
    actions as overlayWindowsActions
} from 'services/overlay-windows/overlay-windows-service';
import {
    OverlayContainer,
    LinkWindow
} from 'components';

import './style.scss';

export interface IMapLinkOverlayProps {
    mapLinkOverlay: MapLinkOverlayOperation;
}
export interface IMapLinkOverlayState {

}

const mapStateToProps = (state: IState) => ({
    mapLinkOverlay: getOperationSafe(state, 'MAP_LINK_OVERLAY')
});

/* eslint-disable @typescript-eslint/indent */
class MapLinkOverlayComponent extends React.Component<
    IMapLinkOverlayProps,
    IMapLinkOverlayState
    > {
    /* eslint-enable @typescript-eslint/indent */

    constructor(props: IMapLinkOverlayProps) {
        super(props);
    }

    render() {
        let { mapLinkOverlay } = this.props;

        if (!mapLinkOverlay.data?.visible) {
            return null;
        }

        return (
            <OverlayContainer
                className='map-link-overlay'
                backgroundOpacity={8}
            >
                <LinkWindow
                    link={mapLinkOverlay.data?.link}
                    onClose={() => {
                        overlayWindowsActions.hideMapLinkOverlay();
                    }}
                />
            </OverlayContainer>
        );
    }
}

export const MapLinkOverlay = connect(mapStateToProps)(MapLinkOverlayComponent);
